import EngagementConnectors from '@/views/admin/engagements/EngagementConnectors.vue';

export default {
  path: '/connectors-configuration/:engagementId',
  name: 'ConnectorsConfiguration',
  component: EngagementConnectors
};
